import { AnimatePresence, m, useReducedMotion } from "framer-motion";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { pageTransition } from "./presets";

export default function PageTransition() {
    const location = useLocation();
    const reduceMotion = useReducedMotion();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [location.pathname, reduceMotion]);

    if (reduceMotion) {
        return <Outlet />;
    }

    return (
        <AnimatePresence mode="wait">
            <m.div
                key={location.pathname}
                initial={pageTransition.initial}
                animate={pageTransition.animate}
                exit={pageTransition.exit}
                transition={pageTransition.transition}
            >
                <Outlet />
            </m.div>
        </AnimatePresence>
    );
}
